import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useSelector } from 'react-redux';
import { transaction } from '../../components/utils/selectors/selectors';
import buttonIcon from '../../assets/buttonIcon.png';
import scheduledMessage from '../../assets/scheduleTable.svg';
import Transfer from '../../assets/TransferTable.svg';
import sentSms from '../../assets/sentSms.svg';
import addedcontacts from '../../assets/addedcontacts.svg';
import topUpIcon from '../../assets/TopupTable.svg';
import { Typography, Button } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import ActivityReceiptDialog from '../../components/modal/ActivityReceiptDialog';
import ActivityReceiptDialogTopup from '../../components/modal/ActivityReceiptDialogTopup';

export default function RecentPaginatedTable({ updatePage, data }) {
   const selector = useSelector(transaction);
   const [page, setPage] = React.useState(1);
   const [transferDialogOpen, setTransferDialogOpen] = React.useState(false);
   const [topupDialogOpen, setTopupDialogOpen] = React.useState(false);
   const [selectedActivity, setSelectedActivity] = React.useState(null);

   const loadmore = () => {
      if (selector.hasMore && selector.loading !== 'pending') {
         setPage(page + 1);
         updatePage(page + 1);
      }
   };

   const handleDetailsClick = (row) => {
      if (row.action === 'Unit transfer') {
         setSelectedActivity(row);
         setTransferDialogOpen(true);
      } else if (row.action === 'Account top-up') {
         setSelectedActivity(row);
         setTopupDialogOpen(true);
      }
   };

   return (
      <>
         <TableContainer
            component={Paper}
            id="scrollableDiv"
            sx={{
               overflowY: 'auto',
               height: '60vh',
               '@media(max-width:606px)': {
                  overflow: 'auto',
               },
            }}
         >
            <Table
               sx={{
                  overflowY: 'auto',
                  height: '60vh',
                  '@media(max-width:606px)': { overflow: 'auto' },
               }}
               aria-label="recent activities table"
            >
               <TableHead sx={{ position: 'sticky', top: 0,zIndex:1 }}>
                  <TableRow sx={{ background: '#eaf2ff', color: '#fff' }}>
                     <TableCell
                        sx={{
                           color: '#2E2C21',
                           width: '25%',
                           fontWeight: '400',
                           textTransform: 'none',
                           fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                           textAlign: 'center'
                        }}
                        align="center"
                     >
                        Action
                     </TableCell>
                     <TableCell
                        sx={{
                           color: '#2E2C21',
                           width: '25%',
                           fontWeight: '400',
                           textTransform: 'none',
                           fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                           textAlign: 'center'
                        }}
                        align="center"
                     >
                        Date
                     </TableCell>
                     <TableCell
                        sx={{
                           color: '#2E2C21',
                           width: '25%',
                           fontWeight: '400',
                           textTransform: 'none',
                           fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                           textAlign: 'center'
                        }}
                        align="center"
                     >
                        Volume
                     </TableCell>
                     <TableCell
                        sx={{
                           color: '#2E2C21',
                           width: '25%',
                           fontWeight: '400',
                           textTransform: 'none',
                           fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                           textAlign: 'center'
                        }}
                        align="center"
                     >
                        Status
                     </TableCell>
                     {/* <TableCell
                        sx={{
                           color: '#2E2C21',
                           width: '25%',
                           fontWeight: '400',
                           textTransform: 'none',
                           fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
                           textAlign: 'center'
                        }}
                        align="center"
                     >
                     </TableCell> */}
                  </TableRow>
               </TableHead>
               <TableBody>
                  {selector?.paginatedActivities &&
                     data.map((row, index) => (
                        <TableRow
                           key={index}
                           sx={{
                              '&:last-child td, &:last-child th': { border: 0 },
                           }}
                        >
                           <TableCell
                              sx={{
                                 width: '25%',
                                 fontWeight: '700',
                                 fontSize: 'clamp(0.85rem, 1.5vw, 0.95rem)',
                              }}
                           >
                              <Typography
                                 sx={{
                                    fontWeight: '700',
                                    fontSize: 'clamp(0.85rem, 1.5vw, 0.95rem)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    whiteSpace: 'nowrap',
                                 }}
                              >
                                 <img
                                    src={
                                       row.action === 'Account top-up'
                                          ? topUpIcon
                                          : row.action === 'Added Contacts'
                                          ? addedcontacts
                                          : row.action === 'Unit transfer'
                                          ? Transfer
                                          : row.action === 'Sender ID'
                                          ? buttonIcon
                                          : row.action === 'Scheduled SMS'
                                          ? scheduledMessage
                                          : sentSms
                                    }
                                    style={{
                                       width:
                                          row.action === 'Scheduled SMS'
                                             ? '25px'
                                             : '30px',
                                       marginRight: '10px',
                                    }}
                                    alt="icon"
                                 />
                                 {row.action}
                              </Typography>
                           </TableCell>
                           <TableCell
                              align="center"
                              sx={{
                                 width: '25%',
                                 fontFamily: "'Raleway', 'Montserrat', sans-serif",
                                 fontWeight: '700',
                                 fontSize: 'clamp(0.85rem, 1.5vw, 0.95rem)',
                              }}
                           >
                              {new Date(row.createdAt).toLocaleDateString(
                                 'en-US',
                                 {
                                    month: '2-digit',
                                    day: '2-digit',
                                    year: 'numeric',
                                 }
                              )}
                           </TableCell>
                           <TableCell
                              align="center"
                              sx={{
                                 width: '25%',
                                 fontFamily: "'Raleway', 'Montserrat', sans-serif",
                                 fontWeight: '700',
                                 fontSize: 'clamp(0.85rem, 1.5vw, 0.95rem)',
                              }}
                           >
                              {`${row.value} ${row.unit}`}
                           </TableCell>
                           <TableCell
                              align="center"
                              sx={{
                                 width: '25%',
                                 fontFamily: "'Raleway', 'Montserrat', sans-serif",
                                 fontWeight: '700',
                                 fontSize: 'clamp(0.85rem, 1.5vw, 0.95rem)',
                                 color:
                                    row.status === 'Success'
                                       ? '#0FA958'
                                       : row.status === 'In Progress'
                                       ? '#0BA9E0'
                                       : '#FF3F3F',
                              }}
                           >
                              {row.status}
                           </TableCell>
                           {/* <TableCell align="center">
                              <Button
                                 variant="outlined"
                                 size="small"
                                 onClick={() => handleDetailsClick(row)}
                                 sx={{
                                    textTransform: 'none',
                                    zIndex: 0,
                                    fontWeight: 400,
                                    color: '#58564d',
                                    borderColor: '#D0D0D0',
                                    fontSize: '1rem',
                                    borderRadius: '5px',
                                    px: 2.2,
                                    py: 0.5,
                                    backgroundColor: '#FFFFFF',
                                    '&:hover': {
                                       backgroundColor: '#F7F7F7',
                                       borderColor: '#DADADA',
                                    },
                                    '& .MuiButton-startIcon': { marginRight: 0 },
                                 }}
                              >
                                 Details
                              </Button>
                           </TableCell> */}
                        </TableRow>
                     ))}
                  <tr>
                     {/* <PaginationXD
                        totalPosts={selector?.paginate && selector?.paginate}
                        paginate={paginate}
                     /> */}
                  </tr>
               </TableBody>
            </Table>
            <InfiniteScroll
               dataLength={data.length}
               next={loadmore}
               hasMore={selector.hasMore}
               loader={
                  <h4 style={{ textAlign: 'center', margin: '15px 0' }}>
                     Loading...
                  </h4>
               }
               scrollableTarget="scrollableDiv"
               endMessage={
                  <p style={{ textAlign: 'center', margin: '15px 0' }}>
                     Yay! You have seen it all
                  </p>
               }
            />
         </TableContainer>

         <ActivityReceiptDialog
            open={transferDialogOpen}
            onClose={() => setTransferDialogOpen(false)}
            activity={selectedActivity}
         />

         <ActivityReceiptDialogTopup
            open={topupDialogOpen}
            onClose={() => setTopupDialogOpen(false)}
            activity={selectedActivity}
         />
      </>
   );
}